/**
 * Header behaviour: the mobile menu, the search panel and its suggestions,
 * the account dropdown and the forgot-password modal.
 *
 * This lived inline in sections/header.liquid, which meant 24KB of
 * JavaScript inside the HTML of every page of the shop, downloaded again on
 * every navigation and never cached. As a file it is fetched once and served
 * from the browser's cache for a year after that.
 *
 * The one thing it needed from Liquid, the shop's currency, is read from the
 * header element instead of being written into the source.
 */
(function () {
  'use strict';

  const shop = document.querySelector('[data-shop-currency]');
  const currencyCode = (shop && shop.dataset.shopCurrency) || 'USD';

  document.addEventListener('DOMContentLoaded', function () {
    const menuToggle = document.getElementById('mobile-menu-toggle');
    const menuClose = document.getElementById('mobile-menu-close');
    const mobileMenu = document.getElementById('mobile-menu');

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function () {
        // Close account dropdown if open
        const accountDropdown = document.getElementById('account-dropdown-menu');
        if (accountDropdown && !accountDropdown.classList.contains('hidden')) {
          accountDropdown.classList.add('hidden');
        }

        mobileMenu.classList.remove('-translate-x-full');
      });
    }

    if (menuClose && mobileMenu) {
      menuClose.addEventListener('click', function () {
        mobileMenu.classList.add('-translate-x-full');
      });
    }

    // Declare all panel state variables and elements first
    const shopToggle = document.getElementById('shop-toggle');
    const shopPanel = document.getElementById('shop-panel');
    const shopArrow = document.getElementById('shop-arrow');
    let isShopPanelOpen = false;

    const collectionsToggle = document.getElementById('collections-toggle');
    const collectionsPanel = document.getElementById('collections-panel');
    const collectionsArrow = document.getElementById('collections-arrow');
    let isCollectionsPanelOpen = false;

    const aboutToggle = document.getElementById('about-toggle');
    const aboutPanel = document.getElementById('about-panel');
    const aboutArrow = document.getElementById('about-arrow');
    let isAboutPanelOpen = false;

    // Shop panel functionality (desktop only)

    function toggleShopPanel() {
      isShopPanelOpen = !isShopPanelOpen;
      if (shopToggle) shopToggle.setAttribute('aria-expanded', String(isShopPanelOpen));

      // Close other panels if open
      if (isShopPanelOpen && isCollectionsPanelOpen) {
        toggleCollectionsPanel();
      }
      if (isShopPanelOpen && isAboutPanelOpen) {
        toggleAboutPanel();
      }
      if (isShopPanelOpen && isSearchPanelOpen) {
        closeSearchPanel();
      }
      if (isShopPanelOpen && isLoginModalOpen) {
        closeLoginModal();
      }

      if (isShopPanelOpen) {
        shopPanel.classList.remove('hidden');
        // Force reflow
        shopPanel.offsetHeight;
        shopPanel.style.maxHeight = '1000px';
        if (shopArrow) {
          shopArrow.style.transform = 'rotate(180deg)';
        }
      } else {
        shopPanel.style.maxHeight = '0';
        if (shopArrow) {
          shopArrow.style.transform = 'rotate(0deg)';
        }
        setTimeout(() => {
          shopPanel.classList.add('hidden');
        }, 300);
      }
    }

    if (shopToggle) {
      shopToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Close account dropdown if open
        const accountDropdown = document.getElementById('account-dropdown-menu');
        if (accountDropdown && !accountDropdown.classList.contains('hidden')) {
          accountDropdown.classList.add('hidden');
        }

        toggleShopPanel();
      });
    }

    // Collections panel functionality (desktop only)
    function toggleCollectionsPanel() {
      isCollectionsPanelOpen = !isCollectionsPanelOpen;
      if (collectionsToggle)
        collectionsToggle.setAttribute('aria-expanded', String(isCollectionsPanelOpen));

      // Close other panels if open
      if (isCollectionsPanelOpen && isShopPanelOpen) {
        toggleShopPanel();
      }
      if (isCollectionsPanelOpen && isAboutPanelOpen) {
        toggleAboutPanel();
      }
      if (isCollectionsPanelOpen && isSearchPanelOpen) {
        closeSearchPanel();
      }

      if (isCollectionsPanelOpen) {
        collectionsPanel.classList.remove('hidden');
        // Force reflow
        collectionsPanel.offsetHeight;
        collectionsPanel.style.maxHeight = '1000px';
        if (collectionsArrow) {
          collectionsArrow.style.transform = 'rotate(180deg)';
        }
      } else {
        collectionsPanel.style.maxHeight = '0';
        if (collectionsArrow) {
          collectionsArrow.style.transform = 'rotate(0deg)';
        }
        setTimeout(() => {
          collectionsPanel.classList.add('hidden');
        }, 300);
      }
    }

    if (collectionsToggle) {
      collectionsToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Close account dropdown if open
        const accountDropdown = document.getElementById('account-dropdown-menu');
        if (accountDropdown && !accountDropdown.classList.contains('hidden')) {
          accountDropdown.classList.add('hidden');
        }

        toggleCollectionsPanel();
      });
    }

    // About panel functionality (desktop only)
    function toggleAboutPanel() {
      isAboutPanelOpen = !isAboutPanelOpen;
      if (aboutToggle) aboutToggle.setAttribute('aria-expanded', String(isAboutPanelOpen));

      // Close other panels if open
      if (isAboutPanelOpen && isShopPanelOpen) {
        toggleShopPanel();
      }
      if (isAboutPanelOpen && isCollectionsPanelOpen) {
        toggleCollectionsPanel();
      }
      if (isAboutPanelOpen && isSearchPanelOpen) {
        closeSearchPanel();
      }

      if (isAboutPanelOpen) {
        // Position the panel under the About button
        if (aboutToggle) {
          const rect = aboutToggle.getBoundingClientRect();
          aboutPanel.style.left = rect.left + 'px';
        }

        aboutPanel.style.pointerEvents = 'auto';
        aboutPanel.style.opacity = '1';
        // Force reflow
        aboutPanel.offsetHeight;
        aboutPanel.style.maxHeight = '400px';
        if (aboutArrow) {
          aboutArrow.style.transform = 'rotate(180deg)';
        }
      } else {
        aboutPanel.style.maxHeight = '0';
        aboutPanel.style.opacity = '0';
        if (aboutArrow) {
          aboutArrow.style.transform = 'rotate(0deg)';
        }
        setTimeout(() => {
          aboutPanel.style.pointerEvents = 'none';
        }, 300);
      }
    }

    if (aboutToggle) {
      aboutToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Close account dropdown if open
        const accountDropdown = document.getElementById('account-dropdown-menu');
        if (accountDropdown && !accountDropdown.classList.contains('hidden')) {
          accountDropdown.classList.add('hidden');
        }

        toggleAboutPanel();
      });
    }

    // Close panels when clicking outside
    document.addEventListener('click', function (e) {
      // Close shop panel
      if (
        isShopPanelOpen &&
        shopPanel &&
        !shopPanel.contains(e.target) &&
        !shopToggle?.contains(e.target)
      ) {
        toggleShopPanel();
      }
      // Close collections panel
      if (
        isCollectionsPanelOpen &&
        collectionsPanel &&
        !collectionsPanel.contains(e.target) &&
        !collectionsToggle?.contains(e.target)
      ) {
        toggleCollectionsPanel();
      }
      // Close about panel
      if (
        isAboutPanelOpen &&
        aboutPanel &&
        !aboutPanel.contains(e.target) &&
        !aboutToggle?.contains(e.target)
      ) {
        toggleAboutPanel();
      }
    });

    /* Desktop hover-to-open.
     *
     * Layered on top of click rather than replacing it. Click stays the
     * mechanism on touch screens, where hover does not exist, and for
     * keyboard users pressing Enter or Space on the button.
     *
     * Gated on a real hovering pointer so that a tap on a phone cannot fire
     * a synthetic mouseenter and leave a panel stuck open.
     */
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // Grace period so that moving the pointer across the gap between a
    // button and its panel does not close the panel on the way.
    const HOVER_CLOSE_DELAY = 220;

    if (canHover) {
      let hoverCloseTimer = null;

      const cancelHoverClose = function () {
        if (hoverCloseTimer) {
          clearTimeout(hoverCloseTimer);
          hoverCloseTimer = null;
        }
      };

      [
        {
          button: shopToggle,
          panel: shopPanel,
          isOpen: function () {
            return isShopPanelOpen;
          },
          toggle: toggleShopPanel,
        },
        {
          button: collectionsToggle,
          panel: collectionsPanel,
          isOpen: function () {
            return isCollectionsPanelOpen;
          },
          toggle: toggleCollectionsPanel,
        },
        {
          button: aboutToggle,
          panel: aboutPanel,
          isOpen: function () {
            return isAboutPanelOpen;
          },
          toggle: toggleAboutPanel,
        },
      ].forEach(function (entry) {
        if (!entry.button || !entry.panel) {
          return;
        }

        const openOnHover = function () {
          cancelHoverClose();
          if (!entry.isOpen()) {
            entry.toggle();
          }
        };

        const closeAfterGrace = function () {
          cancelHoverClose();
          hoverCloseTimer = setTimeout(function () {
            if (entry.isOpen()) {
              entry.toggle();
            }
          }, HOVER_CLOSE_DELAY);
        };

        entry.button.addEventListener('mouseenter', openOnHover);
        entry.button.addEventListener('mouseleave', closeAfterGrace);
        entry.panel.addEventListener('mouseenter', cancelHoverClose);
        entry.panel.addEventListener('mouseleave', closeAfterGrace);
      });
    }

    // Escape closes any open nav panel, matching the login modal's behaviour.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') {
        return;
      }
      if (isShopPanelOpen) {
        toggleShopPanel();
      }
      if (isCollectionsPanelOpen) {
        toggleCollectionsPanel();
      }
      if (isAboutPanelOpen) {
        toggleAboutPanel();
      }
    });

    // Account dropdown functionality
    const accountToggle = document.getElementById('account-toggle');
    const accountDropdown = document.getElementById('account-dropdown-menu');

    if (accountToggle && accountDropdown) {
      accountToggle.addEventListener('click', function (e) {
        e.stopPropagation();

        // If login panel is open, close it
        if (isLoginModalOpen) {
          closeLoginModal();
          return;
        }

        // Close other panels if opening dropdown
        if (accountDropdown.classList.contains('hidden')) {
          if (isShopPanelOpen) toggleShopPanel();
          if (isCollectionsPanelOpen) toggleCollectionsPanel();
          if (isAboutPanelOpen) toggleAboutPanel();
          if (isSearchPanelOpen) closeSearchPanel();
        }

        accountDropdown.classList.toggle('hidden');
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!accountToggle.contains(e.target) && !accountDropdown.contains(e.target)) {
          accountDropdown.classList.add('hidden');
        }
      });

      // Prevent dropdown from closing when clicking inside it
      accountDropdown.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    // Login panel functionality
    const signInTrigger = document.getElementById('sign-in-trigger');
    const loginModal = document.getElementById('login-modal');
    const loginModalClose = document.getElementById('login-modal-close');
    let isLoginModalOpen = false;

    function openLoginModal() {
      if (isLoginModalOpen) return;
      isLoginModalOpen = true;

      // Close account dropdown
      if (accountDropdown) {
        accountDropdown.classList.add('hidden');
      }

      // Close other panels
      if (isShopPanelOpen) toggleShopPanel();
      if (isCollectionsPanelOpen) toggleCollectionsPanel();
      if (isAboutPanelOpen) toggleAboutPanel();
      if (isSearchPanelOpen) closeSearchPanel();

      loginModal.style.pointerEvents = 'auto';
      loginModal.style.opacity = '1';
      loginModal.style.maxHeight = '600px';

      // Focus first input after animation
      setTimeout(() => {
        document.getElementById('customer-email')?.focus();
      }, 300);
    }

    function closeLoginModal() {
      if (!isLoginModalOpen) return;
      isLoginModalOpen = false;

      loginModal.style.opacity = '0';
      loginModal.style.maxHeight = '0';
      setTimeout(() => {
        loginModal.style.pointerEvents = 'none';
      }, 300);
    }

    if (signInTrigger) {
      signInTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openLoginModal();
      });
    }

    if (loginModalClose) {
      loginModalClose.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeLoginModal();
      });
    }

    // Close login panel on ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isLoginModalOpen) {
        closeLoginModal();
      }
    });

    // Close login panel when clicking outside
    document.addEventListener('click', function (e) {
      if (isLoginModalOpen && loginModal && !loginModal.contains(e.target)) {
        closeLoginModal();
      }
    });

    // Search panel functionality
    const desktopSearchToggle = document.getElementById('desktop-search-toggle');
    const mobileSearchToggle = document.getElementById('mobile-search-toggle');
    const searchPanel = document.getElementById('search-panel');
    const searchInput = document.getElementById('search-input');
    const searchClose = document.getElementById('search-close');
    const searchResults = document.getElementById('search-results');
    let searchTimeout;
    let isSearchPanelOpen = false;

    function openSearchPanel() {
      if (isSearchPanelOpen) return;
      isSearchPanelOpen = true;

      // Close other panels
      if (isShopPanelOpen) toggleShopPanel();
      if (isCollectionsPanelOpen) toggleCollectionsPanel();
      if (isAboutPanelOpen) toggleAboutPanel();

      searchPanel.style.pointerEvents = 'auto';
      searchPanel.style.opacity = '1';
      searchPanel.style.maxHeight = '600px';

      // Focus input after animation
      setTimeout(() => {
        searchInput.focus();
      }, 300);
    }

    function closeSearchPanel() {
      if (!isSearchPanelOpen) return;
      isSearchPanelOpen = false;

      searchPanel.style.opacity = '0';
      searchPanel.style.maxHeight = '0';
      setTimeout(() => {
        searchPanel.style.pointerEvents = 'none';
        searchInput.value = '';
        searchResults.innerHTML = '';
      }, 300);
    }

    if (desktopSearchToggle) {
      desktopSearchToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Close account dropdown if open
        const accountDropdown = document.getElementById('account-dropdown-menu');
        if (accountDropdown && !accountDropdown.classList.contains('hidden')) {
          accountDropdown.classList.add('hidden');
        }

        if (isSearchPanelOpen) {
          closeSearchPanel();
        } else {
          openSearchPanel();
        }
      });
    }

    if (mobileSearchToggle) {
      mobileSearchToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Close account dropdown if open
        const accountDropdown = document.getElementById('account-dropdown-menu');
        if (accountDropdown && !accountDropdown.classList.contains('hidden')) {
          accountDropdown.classList.add('hidden');
        }

        if (isSearchPanelOpen) {
          closeSearchPanel();
        } else {
          openSearchPanel();
        }
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeSearchPanel();
      });
    }

    // Close search panel on ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isSearchPanelOpen) {
        closeSearchPanel();
      }
    });

    // Close search panel when clicking outside
    document.addEventListener('click', function (e) {
      if (
        isSearchPanelOpen &&
        searchPanel &&
        !searchPanel.contains(e.target) &&
        !desktopSearchToggle?.contains(e.target) &&
        !mobileSearchToggle?.contains(e.target)
      ) {
        closeSearchPanel();
      }
    });

    // Predictive search functionality
    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        const query = e.target.value.trim();

        // Clear previous timeout
        clearTimeout(searchTimeout);

        if (query.length < 2) {
          searchResults.innerHTML = '';
          return;
        }

        // Show loading state
        searchResults.innerHTML =
          '<div class="text-white/60 text-center py-4" style="font-family: var(--font-lato);">Searching...</div>';

        // Debounce search
        searchTimeout = setTimeout(() => {
          fetch(
            `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`,
          )
            .then((response) => response.json())
            .then((data) => {
              const products = data.resources.results.products || [];

              if (products.length === 0) {
                searchResults.innerHTML =
                  '<div class="text-white/60 text-center py-4" style="font-family: var(--font-lato);">No products found</div>';
                return;
              }

              // Render product results
              let html = '<div class="flex flex-col gap-1">';
              products.forEach((product) => {
                const price = new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: currencyCode,
                }).format(product.price);

                // The photograph, because in this catalogue the words are
                // the least distinguishing part: 143 products are called
                // "<something> Vintage Tee - Retro College Mascot Shirt".
                // suggest.json already carries the image URL, so it costs
                // no extra request; width is appended to the existing query
                // because the URL always arrives with ?v= on it.
                //
                // Not lazy: the panel opens from a height of zero, so a
                // lazy image inside it never comes into view and never
                // loads. Eight thumbnails, and only once someone searches.
                const thumb = product.image
                  ? `<img src="${product.image}&width=160" alt="" width="56" height="56" class="h-14 w-14 shrink-0 object-cover bg-[#333]">`
                  : '<span class="h-14 w-14 shrink-0 bg-[#333]"></span>';

                html += `
                  <a href="${product.url}" class="flex items-center gap-3 p-2 hover:bg-white/5 transition-colors rounded no-underline">
                    ${thumb}
                    <span class="flex min-w-0 flex-col gap-1">
                      <span class="text-white text-[15px] leading-[1.2] font-bold m-0" style="font-family: var(--font-futura);">${product.title}</span>
                      <span class="text-white/80 text-[14px] m-0" style="font-family: var(--font-lato);">${price}</span>
                    </span>
                  </a>
                `;
              });
              html += '</div>';

              // Add "View all results" link
              html += `
                <div class="mt-4 pt-4 border-t border-white/20">
                  <a href="/search?q=${encodeURIComponent(query)}" class="block text-center text-white text-[14px] uppercase font-bold hover:text-brand-orange transition-opacity no-underline" style="font-family: var(--font-futura);">
                    View All Results
                  </a>
                </div>
              `;

              searchResults.innerHTML = html;
            })
            .catch((error) => {
              console.error('Search error:', error);
              searchResults.innerHTML =
                '<div class="text-white/60 text-center py-4" style="font-family: var(--font-lato);">Search error. Please try again.</div>';
            });
        }, 300);
      });
    }

    // Forgot Password Modal Handler
    const forgotPasswordModal = document.getElementById('forgot-password-modal-header');
    const forgotPasswordTrigger = document.getElementById('forgot-password-trigger-header');
    const closeModalBtn = document.getElementById('close-modal-header');
    const cancelModalBtn = document.getElementById('cancel-modal-header');
    const recoverFormHeader = forgotPasswordModal
      ? forgotPasswordModal.querySelector('form')
      : null;
    const emailInputHeader = document.getElementById('RecoverEmail-header');
    const successDivHeader = document.getElementById('recover-success-header');
    const errorDivHeader = document.getElementById('recover-error-header');
    const errorMessageHeader = document.getElementById('recover-error-message-header');

    // A <dialog> now, shared with the login page through
    // snippets/reset-password. Escape, returning focus to whatever opened
    // it, and holding focus inside are the element's own doing.
    function openForgotPasswordModal() {
      if (!forgotPasswordModal || typeof forgotPasswordModal.showModal !== 'function') return;
      forgotPasswordModal.showModal();
      if (emailInputHeader) emailInputHeader.focus();

      // Close the login modal if it's open
      if (isLoginModalOpen) {
        closeLoginModal();
      }
    }

    function closeForgotPasswordModal() {
      if (!forgotPasswordModal || typeof forgotPasswordModal.close !== 'function') return;
      forgotPasswordModal.close();
      if (emailInputHeader) emailInputHeader.value = '';
      if (successDivHeader) successDivHeader.classList.add('hidden');
      if (errorDivHeader) errorDivHeader.classList.add('hidden');
    }

    // Open modal
    if (forgotPasswordTrigger) {
      forgotPasswordTrigger.addEventListener('click', openForgotPasswordModal);
    }

    // Close modal
    if (closeModalBtn) {
      closeModalBtn.addEventListener('click', closeForgotPasswordModal);
    }
    if (cancelModalBtn) {
      cancelModalBtn.addEventListener('click', closeForgotPasswordModal);
    }

    // Close on backdrop click. The backdrop is the dialog itself, so a
    // click that landed on no child of the panel is a click outside it.
    if (forgotPasswordModal) {
      forgotPasswordModal.addEventListener('click', (e) => {
        if (!e.target.closest('[data-reset-body]')) {
          closeForgotPasswordModal();
        }
      });
    }

    // Handle form submission
    if (recoverFormHeader) {
      recoverFormHeader.addEventListener('submit', (e) => {
        if (errorDivHeader) errorDivHeader.classList.add('hidden');

        if (emailInputHeader && (!emailInputHeader.value || !emailInputHeader.validity.valid)) {
          e.preventDefault();
          if (errorMessageHeader)
            errorMessageHeader.textContent = 'Please enter a valid email address.';
          if (errorDivHeader) errorDivHeader.classList.remove('hidden');
          return false;
        }

        // Form will submit normally to Shopify's recover_customer_password endpoint
      });
    }

    // Check if we're on the password recovery success page
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('recover') === 'success') {
      openForgotPasswordModal();
      if (successDivHeader) successDivHeader.classList.remove('hidden');
      setTimeout(() => {
        closeForgotPasswordModal();
      }, 5000);
    }
  });
})();

/*
 * The header gets out of the way going down the page, and comes back the
 * moment you head up.
 *
 * It is fixed, so it was sitting on 98px of every screen at all times. It
 * still is when you want it: the reveal is on any upward movement, so it
 * arrives before you have finished asking for it, rather than only at the
 * top of the page.
 *
 * Nothing below it moves. Sections reserve the header's height with
 * padding, and that padding is unchanged whether it is on screen or not,
 * so hiding it does not reflow the page -- it only uncovers what was
 * already underneath.
 *
 * What does follow it is --header-offset, which the two sticky things on
 * the site are pinned to: the filter bar on a collection and the buy
 * column on a product. Left at the header's height they would have hung
 * 98px down the window with the page running underneath them.
 *
 * It stays put while anything is open under it -- a menu panel, the
 * search, the mobile drawer -- because those are drawn from its bottom
 * edge and would be left floating. Open is asked of the computed style
 * rather than of a class: the panels do not agree on how they hide. Shop
 * and Collections add .hidden, About keeps .hidden only below lg and goes
 * by opacity above it, Search and the login modal never carry the class
 * at all, and the drawer is simply pushed off the side. What they do
 * agree on is that a shut one cannot be clicked.
 *
 * And it never hides in the first screenful, where there is nothing to
 * gain and the movement reads as a flicker.
 */
(function () {
  const header = document.querySelector('header[data-shop-currency]');
  if (!header) return;

  const root = document.documentElement;
  const PANELS = [
    'shop-panel',
    'collections-panel',
    'about-panel',
    'search-panel',
    'login-modal',
    'account-dropdown-menu',
    'mobile-menu',
  ];

  let lastY = window.scrollY;
  let hidden = false;
  let queued = false;

  function anythingOpen() {
    return PANELS.some(function (id) {
      const el = document.getElementById(id);
      if (!el) return false;

      // The drawer is pushed off the side, not hidden: it stays clickable
      // out there, so it has to be asked about its position instead.
      if (id === 'mobile-menu') {
        return !el.classList.contains('-translate-x-full');
      }

      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      if (style.pointerEvents === 'none') return false;
      if (parseFloat(style.opacity) === 0) return false;

      // Shop and Collections stay in the flow while they collapse.
      return el.getBoundingClientRect().height > 1;
    });
  }

  function show() {
    if (!hidden) return;
    hidden = false;
    header.removeAttribute('data-tucked');
    root.style.removeProperty('--header-offset');
  }

  function hide() {
    if (hidden) return;
    hidden = true;
    header.setAttribute('data-tucked', '');
    root.style.setProperty('--header-offset', '0px');
  }

  function onScroll() {
    queued = false;
    const y = window.scrollY;
    const delta = y - lastY;

    // Elastic overscroll and a trackpad at rest both report movement of a
    // pixel or two, which is not a direction.
    if (Math.abs(delta) < 4) return;
    lastY = y;

    if (delta < 0 || y <= header.offsetHeight * 2) {
      show();
    } else if (!hidden && !anythingOpen()) {
      hide();
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(onScroll);
    },
    { passive: true }
  );
})();
